export default __webpack_public_path__ + "static/media/749.eeeb5cf6.png";